export enum ViewWindowIndex {
  Empty = 0,
  Coronal = 1,
  Axial = 2,
  Sagittal = 3,
  Model3D = 4,
}
